<div id="alerts-container">
  <div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
      <a class="close" (click)="removeAlert(alert)"><i class="mdi mdi-close"></i></a>
      <span [innerHTML]="alert.message"></span>
  </div>
</div>